<ion-content class="ion-padding">
  <div class="campaigns-wrapper" *ngIf="!isOnlyCrowdinvestor">
    <ng-container *ngIf="campaigns.length">
      <h1>{{ 'IMPACT.supportedCampaign.title' | translate }}</h1>
      <swiper-container [modules]="swiperModules" [slidesPerView]="slidesPerView" [spaceBetween]="10" [scrollbar]="true">
        <swiper-slide *ngFor="let campaign of campaigns">
          <div (click)="openCampaignDetail(campaign)" class="card-wrapper" [ngClass]="{ active: campaign.attributes.isPublicis }">
            <img [src]="campaign.attributes.image" *ngIf="!campaign.attributes.isPublicis" />
            <ion-icon *ngIf="campaign.attributes?.liked" name="hearts"></ion-icon>
            <label [ngClass]="{ ongoing: !campaign.attributes.expired }">
              <ng-container *ngIf="campaign.attributes.expired || campaign.attributes.remaining.days >= 10; else remainingDate">
                {{
                  (campaign.attributes.expired ? 'IMPACT.supportedCampaign.labels.finished' : 'IMPACT.supportedCampaign.labels.ongoing') | translate
                }}
              </ng-container>
              <ng-template #remainingDate>
                <ng-container *ngIf="campaign.attributes.remaining.days !== 0 && campaign.attributes.remaining.minutes !== 0; else showHours">
                  <ng-container *ngIf="campaign.attributes.remaining.totalDays > 1; else showLastDay">
                    {{
                      'IMPACT.supportedCampaign.labels.remaining.days'
                        | translate
                          : {
                              days:
                                campaign.attributes.remaining.totalDays > campaign.attributes.remaining.days
                                  ? campaign.attributes.remaining.totalDays
                                  : campaign.attributes.remaining.days
                            }
                    }}
                  </ng-container>
                  <ng-template #showLastDay>{{ 'IMPACT.supportedCampaign.labels.remaining.day' | translate }}</ng-template>
                </ng-container>
                <ng-template #showHours>
                  <ng-container *ngIf="campaign.attributes.remaining.totalHours > 1; else showLastHour">
                    {{
                      'IMPACT.supportedCampaign.labels.remaining.hours'
                        | translate
                          : {
                              hours:
                                campaign.attributes.remaining.totalHours > campaign.attributes.remaining.hours
                                  ? campaign.attributes.remaining.totalHours
                                  : campaign.attributes.remaining.hours
                            }
                    }}
                  </ng-container>
                  <ng-template #showLastHour>{{ 'IMPACT.supportedCampaign.labels.remaining.hour' | translate }}</ng-template>
                </ng-template>
              </ng-template>
            </label>

            <ng-container *ngIf="campaign.attributes.isPublicis">
              <h2 [ngClass]="{ long: !language.includes('en'), liked: campaign.attributes.liked, narrow: campaigns.length > 1 }">
                {{ 'IMPACT.publicisCampaign.counter.title' | translate }}
              </h2>
              <div class="supporters" [ngClass]="{ narrow: !language.includes('en') && campaigns.length > 1 }">
                <p class="numbers">{{ campaign?.attributes.supporters_number | thousand }}</p>
                <span [innerHTML]="'IMPACT.publicisCampaign.counter.supporter' | translate"></span>
              </div>
              <button class="outline outline--white" *ngIf="!campaign.attributes.liked; else showInvite">
                {{ 'IMPACT.publicisCampaign.counter.button' | translate }}
              </button>
              <ng-template #showInvite>
                <span class="invite-friend" *ngIf="!campaign.attributes.expired">
                  {{ 'IMPACT.publicisCampaign.counter.inviteFriends' | translate }}
                </span>
              </ng-template>
            </ng-container>
          </div>
        </swiper-slide>
      </swiper-container>
    </ng-container>

    <ng-container *ngIf="appLocation === 'ch' || isGrowCustomer">
      <app-home-impact-grow class="grow-impact"></app-home-impact-grow>
    </ng-container>

    <ng-container *ngIf="has3b3aAccount">
      <div class="impact-header">
        <h1>{{ 'IMPACT.title' | translate }}</h1>
        <p>{{ 'IMPACT.subTitle' | translate }}</p>
      </div>
      <ng-container *ngIf="isMetricLoading$ | async; else showMetrics">
        <ion-skeleton-text animated class="impact"></ion-skeleton-text>
        <ion-skeleton-text animated class="impact"></ion-skeleton-text>
        <ion-skeleton-text animated class="impact"></ion-skeleton-text>
      </ng-container>
      <ng-template #showMetrics>
        <app-home-impact-metrics [impactMetrics]="impactMetrics"></app-home-impact-metrics>
      </ng-template>
    </ng-container>
  </div>

  <ng-container *ngIf="isCrowdInvestor">
    <div class="rights-intro">
      <div class="title">{{ 'OVERVIEW.rights.title' | translate }}</div>
      <div>{{ 'OVERVIEW.rights.p' | translate }}</div>
    </div>
    <div class="shareholder-rights" *ngFor="let item of ['AGM', 'voting', 'reports']">
      <img [src]="'../../assets/images/' + item + '.png'" />
      <div>
        <div class="title">{{ 'OVERVIEW.rights.' + item + '.title' | translate }}</div>
        <div>{{ 'OVERVIEW.rights.' + item + '.p' | translate }}</div>
      </div>
    </div>
  </ng-container>
</ion-content>
